<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <header class="content__title pl-0">
            <h1>Associations</h1>

            <div class="actions">
                <a class="btn btn-success btn--icon" @click.prevent="showCreateDialog"
                   v-b-tooltip.left title="Add new association"><i class="zmdi zmdi-plus"></i></a>
            </div>
        </header>

        <div class="card">

            <div class="bg-primary align-items-center d-flex">
                <h5 class="card-header text-white">All Associations</h5>
                <b-pagination align="right" class="my-auto mr-2 ml-auto"
                              :total-rows="pagination.total"
                              v-model="pagination.page"
                              :per-page="pagination.limit"
                />
            </div>


            <b-table hover stacked="md" :items="tableData" sort-by="name" :fields="table.fields"
                     :per-page="pagination.limit" :current-page="pagination.page"
                     :show-empty="true">
                <template slot="badges" slot-scope="data">
                    <span class="badge badge-danger" v-if="data.item.deleted_at">
                    Disabled
                    </span>
                    <span class="badge badge-warning" v-if="data.item.cropType && data.item.cropType.deleted_at">
                        Crop Type Disabled
                    </span>
                    <span class="badge badge-warning" v-if="!data.item.cropType">
                        Crop Type Unassigned
                    </span>
                </template>
                <template slot="cropType" slot-scope="data">
                    <template v-if="data.item.cropType">{{ data.item.cropType.name }}</template>
                    <span class="text-muted" v-else>(none)</span>
                </template>
                <template slot="actions" slot-scope="row">
                    <b-button @click="showEditDialog(row.item)" variant="secondary btn--icon" v-b-tooltip.hover="'Edit Association'">
                        <i class="zmdi zmdi-edit"></i>
                    </b-button>
                </template>
            </b-table>
        </div>
        <CreateModal :close="closeCreateDialog" v-model="creating" v-if="creating" />
        <EditModal :close="closeEditDialog" :association="editingAssociation" v-model="editingAssociation" v-if="editingAssociation" />
    </div>
</template>

<script>
import listAssociationsQuery from '@views/Associations/Browse/queryListAssociations.graphql';
import CreateModal from './CreateModal';
import EditModal from './EditModal';

export default {
  name: 'BrowseAssociations',
  apollo: {
    associations: {
      query: listAssociationsQuery,
      variables: { input: { include_deleted: true } },
      manual: true,
      result({ data, loading }) {
        if (!loading) {
          this.associations = data.filterAssociations.data;
          this.pagination.total = data.filterAssociations.meta.total;
        }
      },
    },
  },
  data() {
    return {
      loading: 0,
      associations: [],
      editingAssociation: null,
      creating: false,
      pagination: {
        page: 1,
        total: 0,
        limit: this.$tableDefaultPageSize,
      },
      table: {
        fields: [
          {
            key: 'name',
            label: 'Association',
            sortable: true,
          },
          {
            key: 'cropType',
            label: 'Crop Type',
          },
          {
            key: 'badges',
            label: 'Statuses',
          },
          {
            key: 'actions',
            label: '',
            tdClass: 'text-right',
          },
        ],
      },
    };
  },
  computed: {
    tableData() {
      return (this.associations || []).map(item => ({
        ...item,
      }));
    },
  },
  methods: {
    showEditDialog(association) {
      this.editingAssociation = association;
    },
    closeEditDialog() {
      this.editingAssociation = null;
    },
    showCreateDialog() {
      this.creating = true;
    },
    closeCreateDialog() {
      this.creating = false;
    },
  },
  components: {
    EditModal,
    CreateModal,
  },
};
</script>
